import styled from 'styled-components';

export const Container = styled.div`

.select-documents {
  width: 4em;

  @media only screen and (max-width: 768px) {
      width: 100%;

      & > div {
        margin: 0 auto;
      }
  }

  svg {
    margin-top: 5px;
  }
}

.btn-link {
  color: #000 !important;
}



@media only screen and (max-width: 768px) {
  .table-card-responsive {
    thead {
      display: none;
    }

    td {
      display: block;
      border: 0;
      position: relative;
      padding: 0.5em 0.5em 0.5em 30%;

      &:before {
          content: attr(data-title);
          position: absolute;
          top: 0.5em;
      		left: 0.5em;
      		width: 45%;
          white-space: nowrap;
          font-weight: bold;
      }

      &.no-data-title {
        padding: 0.5em;
      }
    }

    tr {
      display: block;
      margin-bottom: 15px;
      border: 1px solid #ccc;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .select-documents {
      padding: 0;

      div {
        margin: 0 5%;
      }
    }
  }
}

}
`;
